export class EticketBooking {
    constructor (_bookingnumber, _bookedtime, _queuePosition, _unitNumber, _numberOfPeople)
    {
        this.bookingNumber = _bookingnumber;
        this.bookedTime = _bookedtime; 
        this.queuePosition = _queuePosition;
        this.unitNumber = _unitNumber;
        this.numberOfPeople = _numberOfPeople;
    }
}